<template>
  <div class="page js-topcateg-landing">
    <h1 class="sr-only">关于基金会</h1>
    <div class="m-foundation js-section layout layout--full-width">
      <div class="c-minisite-banner text--white">
        <div class="c-minisite-banner__background">
          <picture class="c-minisite-banner__picture">
            <source
              media="(min-width: 1024px)"
              srcset="
                @/assets/imgs/CMS-pages/the-sisley-foundation/img-3400@2x.jpg,
                @/assets/imgs/CMS-pages/the-sisley-foundation/img-3400@2x.jpg 2x
              "
            />
            <source
              media="(min-width: 768px)"
              srcset="
                @/assets/imgs/CMS-pages/the-sisley-foundation/img-3400-md@2x.jpg,
                @/assets/imgs/CMS-pages/the-sisley-foundation/img-3400-md@2x.jpg 2x
              "
            />
            <source
              media="(min-width: 0px)"
              srcset="
                @/assets/imgs/CMS-pages/the-sisley-foundation/img-3400-xs@2x.jpg,
                @/assets/imgs/CMS-pages/the-sisley-foundation/img-3400-xs@2x.jpg 2x
              "
            />
            <img
              class="image--full-width image--fit lazyloaded"
              alt="Sisley基金会"
              srcset="@/assets/imgs/CMS-pages/the-sisley-foundation/img-3400@2x.jpg 2x"
              src="@/assets/imgs/CMS-pages/the-sisley-foundation/img-3400@2x.jpg"
            />
          </picture>
        </div>
        <div class="c-minisite-banner__content">
          <div class="layout c-container c-container--minisite">
            <div class="ms-row collapsed">
              <div class="col-xs-12 col-sm-12 col-md-12 col-md-offset-1">
                <span class="c-minisite-title c-minisite-title--highlight">基金会的宗旨： <br />致力<br />造就不凡</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-foundation js-section layout layout--full-width">
      <div class="c-minisite-content c-minisite-content--pre-carousel animatedParent animateOnce" style="background: #648993; color: #ffffff">
        <div class="layout c-container c-container--minisite">
          <div class="ms-row">
            <div class="col-xs-12 col-sm-7 col-md-4 col-md-offset-1">
              <div class="c-minisite-title c-minisite-title--secondary text--white" style="min-width: 464px">
                关于我们的 <br /><span class="text--italic">重大事迹</span>
              </div>
              <div class="m-minisite__description heading-h4 text--white">
                <p>Sisley多纳诺基金会成立于2007年，由Sisley创始人与品牌所有人修伯特·多纳诺与夫人伊莎贝尔共同创立。</p>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 col-sm-offset-1 col-md-2 col-md-offset-3 hide">
              <div class="c-minisite-carousel__arrows-container">
                <div class="m-foundation__address text--right">
                  <span class="c-minisite-text--bold">联络 <br />基金会国际:</span><br />fondation@sisley.fr
                </div>
                <div class="c-minisite-carousel__arrows">
                  <div class="c-minisite-carousel__btn c-minisite-carousel__btn--prev slick-arrow"></div>
                  <div class="c-minisite-carousel__btn c-minisite-carousel__btn--next slick-arrow">
                    <div class="c-minisite-slider__spinner">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="52" width="52" viewBox="0 0 75 75">
                        <circle cx="37.5" cy="37.5" r="36" stroke-width="2"></circle>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-minisite-section m-foundation-section js-section layout layout--full-width">
      <div class="c-minisite-content c-minisite-content--carousel c-minisite-content--bottom c-minisite-content--light">
        <div class="c-minisite-carousel__container c-content-carousel c-carousel text--black">
          <div class="layout c-minisite-carousel slick-slider">
            <div>
              <div class="c-minisite-carousel__slide" >
                <div class="c-minisite-carousel__slide-inner">
                  <div class="row center-xs">
                    <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/pitie.jpg" class="c-minisite-carousel__img lazyloaded" alt="Pitié-Salpêtrière醫院" />
                  </div>
                  <div class="row start-xs">
                    <div class="col-xs-12">
                      <div class="c-minisite-tile__title">
                        <span class="text--italic">Pitié-Salpêtrière医院</span>
                      </div>
                    </div>
                  </div>
                  <div class="row start-xs">
                    <div class="col-xs-12 col-sm-8">
                      <div class="c-minisite-carousel__text-secondary">Sisley多纳诺基金会支持Pitié-Salpêtrière医院中儿童、青少年精神科诊疗室，以及接待大厅的整修与翻新。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="c-minisite-carousel__slide" >
                <div class="c-minisite-carousel__slide-inner">
                  <div class="row center-xs">
                    <img src="@/assets/imgs/CMS-pages/the-sisley-foundation/samu-social.jpg" class="c-minisite-carousel__img lazyloaded" alt="Samu Social" />
                  </div>
                  <div class="row start-xs">
                    <div class="col-xs-12">
                      <div class="c-minisite-tile__title">
                        <span class="text--italic">巴黎Samu Social</span>
                      </div>
                    </div>
                  </div>
                  <div class="row start-xs">
                    <div class="col-xs-12 col-sm-8">
                      <div class="c-minisite-carousel__text-secondary">Sisley多纳诺基金会资助Samu Social人道救援组织其新据点的彻底翻修，让他们的妇女在此安身。</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="c-carousel__pagination display-flex-xs center-xs">
            <div class="c-carousel__slider-info">
              <div class="c-carousel__slide-num">
                <div class="c-carousel__next-slide">01</div>
                <div class="c-carousel__current-slide">01</div>
              </div>
              /
              <div class="c-carousel__total-slides-num">02</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-foundation js-section layout layout--full-width">
      <div class="m-foundation-content js-section">
        <div class="m-foundation-content__container-primary text--black" style="background: #fff">
          <div class="layout c-container c-container--minisite animatedParent animateOnce">
            <div class="ms-row animated fadeIn delay-500 go">
              <div class="col-xs-12 col-sm-7 col-lg-5 col-lg-offset-1 first-sm">
                <div class="c-minisite-title c-minisite-title--secondary">
                  <!-- <span class="m-fondation-content__carousel-text-primary--bold">Sisley</span><br /> -->
                  <span class="m-fondation-content__carousel-text-primary--bold">Sisley多纳诺基金会</span><br />
                  <span class="m-fondation-content__carousel-text-primary--italic">
                    十多年诚心承诺
                    </span>
                </div>
              </div>
              <div class="col-xs-12 first-xs col-sm-2 col-sm-offset-3 col-lg-1 col-lg-offset-5 m-fondation-content__box-primary-wrapper">
                <div class="c-minisite-title c-minisite-title--secondary m-foundation-content__image-wrapper">
                  <!--<img src="https://www.sisley-paris.com/on/demandware.static/-/Library-Sites-Sisley/default/dw2791c9dd/minisite/foundation/rectangle.png" class="m-foundation-content__image--primary lazyloaded" alt="Fondation" />-->
                </div>
              </div>
            </div>
            <div class="ms-row animated fadeIn delay-1000 go">
              <div class="col-xs-12 col-lg-5 col-lg-offset-1">
                <div class="m-minisite__description heading-h4">
                  <p class="m-foundation-content__description-primary">十多年来，Sisley多纳诺基金会用心致力于各类慈善项目。在法国基金会(Fondation de France)的支持下，Sisley多纳诺基金会活跃于法国本土和国外的慈善平台，涉猎范畴涵盖教育、文化、医疗健康、环保和团结互助等领域。</p>
                  <p class="m-foundation-content__description-secondary">管理</p>
                  <p class="m-foundation-content__description-primary">基金会的委员由股东、企业员工、多位专业人士和一位来自法国基金会的代表组成。委员会成员每年会面两次。</p>
                </div>
              </div>
            </div>
            <div class="ms-row animated fadeIn delay-1000 go">
              <div class="col-xs-12 col-lg-5 col-lg-offset-1">
                <img
                  class="m-foundation-content__image--secondary lazyloaded"
                  alt="Sisley基金会"
                  src="@/assets/imgs/CMS-pages/the-sisley-foundation/02.jpg"
                />
              </div>
              <div class="col-xs-12 first-xs col-xs-offset-4 col-sm-offset-6 col-lg-5 last-lg col-lg-offset-1">
                <img
                  class="m-foundation-content__image--third lazyloaded"
                  alt="Sisley基金会"
                  src="@/assets/imgs/CMS-pages/the-sisley-foundation/img-0975.png"
                />
              </div>
            </div>
            <div class="ms-row animated fadeIn delay-1000 go">
              <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-lg-5 col-lg-offset-6">
                <div class="m-minisite__description m-foundation-content__text-block--right">
                  <div class="m-quote__sign m-quote__sign--first">
                    <img
                      class="m-quote__sign-img lazyloaded"
                      alt="Sisley基金会"
                      src="@/assets/imgs/CMS-pages/the-sisley-foundation/quote2.svg"
                    />
                  </div>
                  <div class="m-quote__wrapper">
                    <div>我们的基金会名称由两个部分组成：其中一个是家族名称，另一个则是企业名称，后者由我们与员工一同经营和发展。在大家的共同决议下，我们选择创建这家基金会，以支持那些能够带来改变的慈善项目。</div>
                    <div class="m-quote__author col-md-12">Hubert和Isabelle d'Ormano<br />Sisley创始人</div>
                  </div>
                  <div class="m-quote__sign m-quote__sign--last">
                    <img
                      class="m-quote__sign-img lazyloaded"
                      alt="Sisley基金会"
                      src="@/assets/imgs/CMS-pages/the-sisley-foundation/quote1.svg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center-xs m-foundation-content__image-container" style="background: linear-gradient(to bottom,white 50%,white 100px,#648993 50%,#648993 100px);">
          <img
            class="center-xs m-foundation-content__image--fourth lazyloaded"
            alt="Sisley基金会"
            src="@/assets/imgs/CMS-pages/the-sisley-foundation/03.jpg"
          />
        </div>
        <div class="c-foundation-wrapper animatedParent animateOnce" style="background: #648993; color: #fff">
          <div class="layout c-container c-container--minisite animated fadeIn go">
            <div class="ms-row">
              <div class="col-xs-12 col-sm-6 col-lg-5 col-lg-offset-1">
                <div class="m-minisite__description m-foundation-content__text-block--third" style="color: #fff">
                  <div class="m-quote__sign m-quote__sign--start">
                    <img
                      class="m-quote__sign-img lazyloaded"
                      alt="Sisley基金会"
                      src="@/assets/imgs/CMS-pages/the-sisley-foundation/quote2.svg"
                    />
                  </div>
                  <div class="m-quote__wrapper">
                    <div>Sisley多纳诺基金会至今已有十多年的历史。基金会的目标，是支持能够给社会和环境带来积极影响的各类项目，不论其规模大小。通过此类行动，基金会希望推广和宣传各类有用的议题，以便高效地确保可持续发展。</div>
                    <div class="m-quote__author col-md-12">Philippe d'Ornano<br />Sisley总裁</div>
                  </div>
                  <div class="m-quote__sign m-quote__sign--final">
                    <img
                      class="m-quote__sign-img lazyloaded"
                      alt="Sisley基金会"
                      src="@/assets/imgs/CMS-pages/the-sisley-foundation/quote1.svg"
                    />
                  </div>
                </div>
              </div>
              <div class="col-xs-12 first-xs col-xs-offset-4 col-sm-6 last-sm col-sm-offset-0 col-lg-5 col-lg-offset-1">
                <div class="m-minisite__description">
                  <img
                    class="m-foundation-content__image--fifth lazyloaded"
                    alt="Sisley基金会"
                    src="@/assets/imgs/CMS-pages/the-sisley-foundation/04.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="c-newsletter-subscribe c-foundation-newsletter" style="background: #648993">
      <div class="c-newsletter-subscribe__text c-foundation-newsletter__text">
        <div class="c-newsletter-subscribe__form-container layout hide">
          <form novalidate="" action="/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Newsletter-SubscribeFoundation" role="form" method="POST" name="newsletter-footer-form" class="newsletter-footer-form">
            <h3 class="m-foundation-newsletter__title text--no-transform" style="color: #fff">持續了解相關訊息</h3>
            <p id="footer-newsletter-subsctibe-details" class="m-foundation-newsletter__description" style="color: #fff">Sisley基金會現況</p>
            <div class="c-foundation-newsletter__fields">
              <div class="c-newsletter-subscribe__input form-group">
                <input type="email" required="" class="form-control c-input c-input--no-border" pattern="^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$" name="hpEmailSignUp" placeholder="您的電郵" autocomplete="email" />
                <div id="newsletter-foundation-feedback" class="invalid-feedback"></div>
              </div>
              <div class="c-newsletter-subscribe__button">
                <button type="submit" class="c-button c-button--secondary c-button--secondary-reversed-hover c-foundation-newsletter__btn">註冊</button>
              </div>
            </div>
            <div class="c-newsletter-subscribe__message center-sm">
              <div class="js-newsletter-subscribe__message c-newsletter-subscribe__message-wrapper animated fadeInDownShort hide">
                <span class="c-newsletter-subscribe__message-icon js-newsletter-subscribe__icon-success hide">
                  <svg class="svg-inline icon-checkmark" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                    <g fill="none" fill-rule="evenodd">
                      <circle cx="20" cy="20" r="20" fill="#5D8C82"></circle>
                      <path fill="#FFF" d="M28.366 13.268L27.12 14.48l-2.972 2.894-3.596 3.501-3.122 3.039c-.285.278-.58.55-.87.827-.513-.501-1.027-1.004-1.541-1.504-1.19-1.162-2.384-2.325-3.573-3.487-.273-.266-.541-.532-.815-.798-.354-.345-1.007-.373-1.357 0-.35.373-.378.952 0 1.321.744.723 1.487 1.452 2.23 2.175l3.572 3.487.815.798a.998.998 0 0 0 1.357 0l1.247-1.214 2.972-2.894c1.2-1.166 2.398-2.333 3.597-3.5l3.12-3.039c.504-.49 1.027-.97 1.516-1.475.005-.01.014-.014.024-.023.355-.346.384-.98 0-1.321-.384-.346-.978-.369-1.357 0"></path>
                    </g>
                  </svg>
                </span>
                <span class="c-newsletter-subscribe__message-icon js-newsletter-subscribe__icon-error hide">
                  <svg class="svg-inline icon-error" aria-hidden="true" width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->
                    <desc>Created with Sketch.</desc>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="PRODUCT-PAGE-DESK-POP-AJOUT-CART" transform="translate(-509.000000, -589.000000)">
                        <g id="ADD-TO-CART" transform="translate(487.000000, 534.000000)">
                          <g id="CHECK" transform="translate(22.000000, 55.000000)">
                            <g id="picto">
                              <circle id="Oval" fill="#C05050" cx="20" cy="20" r="20"></circle>
                              <path d="M21.4549081,20.5 L27.7959613,14.1590909 C28.0680129,13.8863636 28.0680129,13.4772727 27.7959613,13.2045455 C27.522546,12.9318182 27.1141276,12.9318182 26.8407123,13.2045455 L20.5003409,19.5454545 L14.1592877,13.2045455 C13.8858724,12.9318182 13.477454,12.9318182 13.2040387,13.2045455 C12.9319871,13.4772727 12.9319871,13.8863636 13.2040387,14.1590909 L19.5457738,20.5 L13.2040387,26.8409091 C12.9319871,27.1136364 12.9319871,27.5227273 13.2040387,27.7954545 C13.3410873,27.9318182 13.477454,28 13.6820041,28 C13.8858724,28 14.022921,27.9318182 14.1592877,27.7954545 L20.5003409,21.4545455 L26.8407123,27.7954545 C26.9777609,27.9318182 27.1816291,28 27.3186777,28 C27.4550444,28 27.6595945,27.9318182 27.7959613,27.7954545 C28.0680129,27.5227273 28.0680129,27.1136364 27.7959613,26.8409091 L21.4549081,20.5 Z" id="Fill-1" fill="#FFFFFF"></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
                <span id="footer-newsletter-subscribe-message" class="c-newsletter-subscribe__message-text js-message" role="status" style="color: null"></span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="m-foundation js-section layout layout--full-width">
      <div class="m-foundation-content">
        <div class="c-minisite-content" style="background: #fff; color: #000">
          <div class="layout c-container c-container--minisite">
            <div class="ms-row animatedParent animateOnce">
              <div class="col-xs-12 col-sm-6 col-lg-4 col-lg-offset-1 first-sm animated fadeIn delay-500 go">
                <div class="c-minisite-title c-minisite-title--secondary">
                  <span class="m-fondation-content__carousel-text-primary--bold">基金会</span><br />
                  <span class="m-fondation-content__carousel-text-primary--italic">关键数字</span>
                </div>
              </div>
              <div class="col-xs-12 col-xs-offset-4 first-xs col-sm-2 col-sm-offset-4 col-lg-1 col-lg-offset-5 animated fadeIn delay-1000 go">
                <div class="c-minisite-title c-minisite-title--secondary">
                  <!--<img data-src="https://www.sisley-paris.com/on/demandware.static/-/Library-Sites-Sisley/default/dw2791c9dd/minisite/foundation/rectangle.png" class="m-foundation-content__image--primary lazyload" alt="Fondation" />-->
                </div>
              </div>
            </div>
            <div class="ms-row animatedParent animateOnce">
              <div class="col-xs-12 col-lg-5 col-lg-offset-1 animated fadeIn delay-500 go">
                <div class="m-minisite__description heading-h4">
                  <p class="m-foundation-content__description-primary">
                    建立至今十多年的Sisley多纳诺基金会，一直致力于支持对社会与环境有重大贡献的计划。Sisley基金会希望透过行动，唤起民众关切并持续支持公益事业。
                  </p>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs animatedParent animateOnce">
              <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-500 go">
                <svg width="200" height="100" style="border: 1px solid #375e68;border-bottom: 0;border-top-left-radius: 110px;border-top-right-radius: 110px;opacity: 0.5;">
                  <path id="path"></path>
                </svg>
                <div class="m-foundation-content__arch-text--primary">支持</div>
                <div class="m-foundation-content__arch-text--secondary" style="color: #375e68">5大</div>
                <div class="m-foundation-content__arch--text--third">领域</div>
              </div>
              <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-1000 go">
                <svg width="200" height="100" style="border: 1px solid #375e68;border-bottom: 0;border-top-left-radius: 110px;border-top-right-radius: 110px;opacity: 0.5;">
                  <path id="path"></path>
                </svg>
                <div class="m-foundation-content__arch-text--primary">每年提供超过</div>
								<div class="m-foundation-content__arch-text--secondary" style="color: #53818d">150万</div>
                <div class="m-foundation-content__arch--text--third">欧元捐赠</div>
              </div>
            </div>
            <div class="ms-row center-xs animatedParent animateOnce">
              <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-500 go">
                <svg width="200" height="100" style="border: 1px solid #375e68;border-bottom: 0;border-top-left-radius: 110px;border-top-right-radius: 110px;opacity: 0.5;">
                  <path id="path"></path>
                </svg>
                <div class="m-foundation-content__arch-text--primary">自创立起已为</div>
                <div class="m-foundation-content__arch-text--secondary" style="color: #699aa6">300多个</div>
                <div class="m-foundation-content__arch--text--third">项目提供支持</div>
              </div>
            </div>
            <div class="ms-row center-xs animatedParent animateOnce">
              <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-500 go">
                <svg width="200" height="100" style="border: 1px solid #375e68;border-bottom: 0;border-top-left-radius: 110px;border-top-right-radius: 110px;opacity: 0.5;">
                  <path id="path"></path>
                </svg>
                <div class="m-foundation-content__arch-text--primary">每年</div>
                <div class="m-foundation-content__arch-text--secondary" style="color: #8abbc7">2次</div>
                <div class="m-foundation-content__arch--text--third">委员会议（春季/秋季）</div>
              </div>
              <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-1000 go">
                <svg width="200" height="100" style="border: 1px solid #375e68;border-bottom: 0;border-top-left-radius: 110px;border-top-right-radius: 110px;opacity: 0.5;">
                  <path id="path"></path>
                </svg>
                <div class="m-foundation-content__arch-text--primary">超过</div>
                <div class="m-foundation-content__arch-text--secondary" style="color: #b6d8e0">10%</div>
                <div class="m-foundation-content__arch--text--third">项目来自Sisley员工的提议</div>
              </div>
            </div>
            <div class="ms-row m-foundation-content__actions-container animatedParent animateOnce">
              <div class="col-xs-12 col-sm-6 col-lg-4 col-lg-offset-1 animated fadeIn delay-500 go">
                <div class="c-minisite-title c-minisite-title--secondary">
                  <span class="m-fondation-content__carousel-text-primary--bold">探索</span><br />
                  <span class="m-fondation-content__carousel-text-primary--italic hide">我们的行动</span>
                </div>
              </div>
              <div class="col-sm-2 col-sm-offset-4 col-lg-1 col-lg-offset-5 hide-for-xs-only animated fadeIn delay-500 go">
                <div class="c-minisite-title c-minisite-title--secondary">
                  <!--<img src="https://www.sisley-paris.com/on/demandware.static/-/Library-Sites-Sisley/default/dw2791c9dd/minisite/foundation/rectangle.png" class="m-foundation-content__image--primary lazyloaded" alt="Fondation" />-->
                </div>
              </div>
            </div>
            <div class="ms-row animatedParent animateOnce">
              <div class="col-xs-12 col-sm-12 col-lg-5 col-lg-offset-1 animated fadeIn delay-500 go">
                <div class="m-minisite__description heading-h4">
                  <p class="m-foundation-content__description-primary">Sisley基金会致力于五大领域：</p>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">团结互助</span><br />
                  <span class="m-foundation-content__projects-title--secondary">向有需要的女性伸出援手</span>
                  <br />
                  <!-- <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-solidarity">瀏覽相關計劃</a><br /> -->
                  <a class="link-with-arrow m-foundation-content__projects-title--third" @click="showInnerPage('solidarity')">探索我们支持的项目</a><br />
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">医疗健康</span><br />
                  <span class="m-foundation-content__projects-title--secondary">促进心理和精神健康</span><br />
                  <!-- <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-health">瀏覽相關計劃</a><br /> -->
                  <a class="link-with-arrow m-foundation-content__projects-title--third" @click="showInnerPage('health')">探索我们支持的项目</a><br />
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">教育</span><br />
                  <span class="m-foundation-content__projects-title--secondary">帮助年轻人获取学术成就并顺利就业</span><br />
                  <!-- <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-education">查閱相關計劃</a><br /> -->
                  <a class="link-with-arrow m-foundation-content__projects-title--third" @click="showInnerPage('education')">探索我们支持的项目</a><br />
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">文化</span><br />
                  <span class="m-foundation-content__projects-title--secondary">发展文化项目，促进社会融合</span><br />
                  <!-- <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-culture">瀏覽相關計劃</a><br /> -->
                  <a class="link-with-arrow m-foundation-content__projects-title--third" @click="showInnerPage('culture')">探索我们支持的项目</a><br />
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">环保</span><br />
                  <span class="m-foundation-content__projects-title--secondary">保护生物多样性</span><br />
                  <!-- <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-environment">瀏覽相關計劃</a><br /> -->
                  <a class="link-with-arrow m-foundation-content__projects-title--third" @click="showInnerPage('environment')">探索我们支持的项目</a><br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-foundation js-section layout layout--full-width hide">
      <div class="m-foundation-content">
        <div class="c-minisite-content c-minisite-content__small" style="color: #000; background: #fff">
          <div class="layout c-container c-container--minisite">
            <div class="ms-row m-foundation-content__actions-container m-foundation-content__project-container animatedParent animateOnce">
              <div class="col-xs-12 col-sm-7 col-lg-4 text--no-padding col-lg-offset-1 animated fadeIn delay-500 go">
                <div class="c-minisite-title c-minisite-title--secondary">
                  <span class="m-fondation-content__carousel-text-primary--regular">Découvrir les<br />actions que nous<br />soutenons</span>
                </div>
              </div>
              <div class="col-sm-2 col-sm-offset-4 col-lg-2 col-lg-offset-4 show-for-md animated fadeIn delay-500 go">
                <div class="c-minisite-title c-minisite-title--secondary">
                  <img
                    class="m-foundation-content__image--primary lazyloaded"
                    alt="Fondation"
                    src="https://www.sisley-paris.com/on/demandware.static/-/Library-Sites-Sisley/default/dw098d4361/minisite/foundation/logoFondationSisleyOrnano.svg"
                  />
                </div>
              </div>
            </div>
            <div class="ms-row animatedParent animateOnce">
              <div class="col-xs-12 col-sm-7 col-lg-5 col-lg-offset-1 animated fadeIn delay-500 go">
                <div class="m-minisite__description heading-h4">
                  <p class="m-foundation-content__description-primary">La Fondation intervient dans cinq grands domaines avec, pour chacun, une ligne de force :</p>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 col-sm-10 col-md-6 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">Solidarité</span><br />
                  <span class="m-foundation-content__projects-title--secondary">Sortir de la rue, échapper à la violence, affronter la maladie, prendre en main son parcours professionnel… autant d’épreuves que les femmes accompagnées sont aidées à surmonter grâce à l’appui d’associations bienveillantes.</span><br />
                  <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-solidarity">Voir les projets</a><br />
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 col-sm-10 col-md-6 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">Santé</span><br />
                  <span class="m-foundation-content__projects-title--secondary">Faire des maladies psychiques et mentales une grande cause de santé, c’est l’objectif que s’est fixé la Fondation Sisley à travers un large panorama d’actions : expliquer ces maladies, accompagner les personnes malades et les aidants familiaux, participer à des programmes innovants ou encore financer des travaux de recherche...</span><br />
                  <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-health">Voir les projets</a><br />
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 col-sm-10 col-md-6 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">Éducation</span><br />
                  <span class="m-foundation-content__projects-title--secondary">En soutenant des associations locales et des projets innovants, la Fondation Sisley poursuit deux objectifs : lutter contre l’échec scolaire dès la petite enfance, et favoriser l’insertion des jeunes grâce à des programmes d’expérimentation.</span><br />
                  <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-education">Voir les projets</a><br />
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 col-sm-10 col-md-6 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">Culture</span><br />
                  <span class="m-foundation-content__projects-title--secondary">En tant qu’entreprise française, Sisley a à cœur avec sa Fondation de participer à la préservation du patrimoine culturel, à travers différents projets, souvent proches de ses sites, tout en développant, avec les institutions soutenues, des projets culturels comme levier d’inclusion.</span><br />
                  <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-culture">Voir les projets</a><br />
                </div>
              </div>
            </div>
            <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
              <div class="col-xs-12 col-sm-10 col-md-6 animated fadeIn delay-500 go">
                <div class="m-minisite__description">
                  <span class="m-foundation-content__projects-title--primary">Environnement</span><br />
                  <span class="m-foundation-content__projects-title--secondary">Dans le domaine de l’environnement, la Fondation Sisley s’attache à agir pour la protection de la biodiversité partout dans le monde, à travers la sensibilisation, l’éducation et la formation du plus grand nombre.</span><br />
                  <a class="link-with-arrow m-foundation-content__projects-title--third" data-url="https://www.sisley-paris.com/on/demandware.store/Sites-Sisley_HK-Site/zh_HK/Page-Show?cid=foundation-environment">Voir les projets</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="animatedParent animateOnce m-minisite-foundation__editotial m-minisite-tcf__editotial--padding"></div>
    <!-- 内页 -->
    <div :class="['c-solidarity js-project-modal-wrapper', subjects.current && subjects.config[subjects.current] ? 'opened openToRight' : '']">
      <div class="col-xs-2 col-lg-1 col-lg-offset-1 c-minisite-content" style="z-index: 99;position:absolute; right:30px">
        <button class="l-account-popin__close-button-trigger c-button c-button--rounded c-button--close l-solidarity__btn-close" @click="hideInnerPage">
          <img alt="" class="cross lazyloaded" src="@/assets/imgs/CMS-pages/the-sisley-foundation/cross.svg" />
          <img alt="" class="cross-inverted lazyloaded" src="@/assets/imgs/CMS-pages/the-sisley-foundation/cross-inverted.svg" />
        </button>
      </div>
      <div class="m-foundation-content" v-if="subjects.current && subjects.config[subjects.current]">
        <div class="c-minisite-content" style="background: #fff; color: #000">
          <div class="layout c-container c-container--minisite">
            <div class="ms-row between-xs">
              <div class="col-xs-10 col-lg-4 col-lg-offset-1">
                <div class="c-minisite-title c-minisite-title--secondary">
                  <span>{{subjects.config[subjects.current].title}}</span><br />
                  <span class="m-foundation-content__projects m-foundation-content__projects-number">{{subjects.config[subjects.current].projects_number}}</span>
                  <span class="m-foundation-content__projects">计划</span>
                </div>
              </div>
            </div>
            <!-- 动态加载相对应的页面组件内容 -->
            <component :is="subjects.current"></component>
          </div>
        </div>
      </div>
    </div>
    <!-- 遮罩 -->
    <div class="foundation-modal-background" ref="overlayer"></div>
    <div class="modal-background modal-background--secondary animated"></div>
  </div>
</template>

<script>
require('slick-carousel');

export default {
	name: "TheSisleyFoundation",
  components: {
    solidarity: () => import('@/views/static/FoundationSolidarity'),
    health: () => import('@/views/static/FoundationHealth'),
    education: () => import('@/views/static/FoundationEducation'),
    culture: () => import('@/views/static/FoundationCulture'),
    environment: () => import('@/views/static/FoundationEnvironment')
  },
	data() {
		return {
      kvSwiper: null,
			swiperOpts: {
        loop: true,
        speed: 1000,
        slidesPerView: 1.4,
        spaceBetween: 120,
        autoplay: true,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 24
          }
        }
			},
			kvImages: [
				{
					src: "@/assets/imgs/CMS-pages/the-sisley-foundation/samu-social.jpg",
					title: "巴黎Samu Social",
					intro: "Sisley多纳诺基金会资助Samu Social人道救援组织其新据点的彻底翻修，让他们的妇女在此安身。"
				},
				{
					src: "@/assets/imgs/CMS-pages/the-sisley-foundation/foundation/pitie.jpg",
					title: "Pitié-Salpêtrière医院",
					intro: "Sisley多纳诺基金会支持Pitié-Salpêtrière医院中儿童、青少年精神科诊疗室，以及接待大厅的整修与翻新。"
				}
			],
      subjects: {
        current: "",
        config: {
          solidarity: { title: "团结互助", projects_number: 4 },
          health: { title: "医疗健康", projects_number: 7 },
          education: { title: "教育", projects_number: 3 },
          culture: { title: "文化", projects_number: 5 },
          environment: { title: "环保", projects_number: 5 }
        }
      }
		}
	},
  mounted() { this.initSlick(); },
  methods: {
    initSlick() {
      let slickContainer = $(".c-minisite-carousel");
      let slickBtns = $(".c-minisite-slider__spinner");
      let nextText = $(".c-carousel__next-slide");
      let currText = $(".c-carousel__current-slide");
      let slickCtrl = $(".c-carousel__slider-info");
      // 初始化
      slickContainer.slick({
        infinite: !0,
        speed: 1e3,
        autoplay: !0,
        autoplaySpeed: 5e3,
        arrows: !0,
        nextArrow: '<button type="button" class="c-carousel__btn c-carousel__btn--next c-carousel__arrow--left-aligned slick-arrow"><span class="c-minisite-slider__spinner c-minisite-slider__spinner--black"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="39" width="39" viewbox="0 0 39 39"><circle cx="19.5" cy="19.5" r="18.5" stroke-width="1"/></svg></span></button>',
        prevArrow: '<button type="button" class="c-carousel__btn c-carousel__btn--prev c-carousel__arrow--left-aligned slick-arrow"><span class="c-minisite-slider__spinner c-minisite-slider__spinner--black"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="39" width="39" viewbox="0 0 39 39"><circle cx="19.5" cy="19.5" r="18.5" stroke-width="1"/></svg></span></button>',
        slidesToScroll: 1,
        slidesToShow: 1,
        centerMode: !1,
        variableWidth: !0,
        pauseOnHover: !1,
        mobileFirst: !0,
        adaptiveHeight: !1,
        waitForAnimate: !1,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: "cubic-bezier(0.770, 0.000, 0.175, 1.000)",
            variableWidth: !0,
            variableHeight: !1
          }
        }, {
          breakpoint: 1023,
          settings: {
            variableWidth: !0,
            variableHeight: !1
          }
        }]
      });
      // 过渡开始
      slickContainer.on("beforeChange", (function (e, t, o, s) {
        slickBtns.removeClass("forward").addClass("animate");
        // 
        let sliderCount = +slickCtrl.find(".c-carousel__total-slides-num").text();
        let u = s;
        $(this).hasClass("c-content-carousel") && (window.innerWidth < 1024) && (u = sliderCount > 2 ? 0 == s ? sliderCount - 1 : s - 1 : 0 == s ? 0 : 1);
        nextText.text(u < 9 ? "0" + (u + 1) : u + 1);
        nextText.addClass("shift-top");
        currText.addClass("shift-bottom");
      }));
      // 过渡结束
      slickContainer.on("afterChange", (function (e, t, o) {
        slickBtns.addClass("animate");
        slickBtns.on("animationend", (function () {
          slickBtns.removeClass("animate")
        }));
        // 
        let sliderCount = +slickCtrl.find(".c-carousel__total-slides-num").text();
        let c = o;
        $(this).hasClass("c-content-carousel") && (window.innerWidth < 1024) && (c = sliderCount > 2 ? 0 == o ? 0 : o : 0 == o ? 0 : 1);
        void 0 !== o && currText && currText.text(c < 9 ? "0" + (c + 1) : c + 1);
        nextText.removeClass("shift-top");
        currText.removeClass("shift-bottom");
      }));
      // 暂停 或 继续
      slickCtrl.on("click", (function (e) {
        e.preventDefault();
        e.stopPropagation();
        slickContainer.hasClass("slider-paused") ? slickContainer.slick("slickPlay").removeClass("slider-paused") : slickContainer.slick("slickPause").addClass("slider-paused");
      }));
      // 
      slickBtns.addClass("forward");
      // 控制按钮
      $(document).on("click", ".slick-arrow", (function () {
        var btn = $(this);
        btn.addClass("slick-arrow--animated"), setTimeout((function () {
          btn.removeClass("slick-arrow--animated")
        }), 1e3);
        // 
        var spinner = btn.find(".c-minisite-slider__spinner");
        spinner.addClass("animate-arrow");
        spinner.on("animationend", (function () { spinner.removeClass("animate-arrow"); }));
      }));
    },
    showInnerPage(subject) {
      if (!this.subjects.config[subject]) return console.warn(`内页（${subject}）不存在`), false;
      this.subjects.current = subject;
      document.documentElement.classList.add("no-scroll-html");
      this.$refs.overlayer.style.setProperty("display", "block");
      setTimeout(() => {
        document.querySelector('.header').style.display = 'none'
      }, 300)
    },
    hideInnerPage() {
      document.querySelector('.header').style.display = 'block'
      this.subjects.current = "";
      document.documentElement.classList.remove("no-scroll-html");
      this.$refs.overlayer.style.removeProperty("display");
    }
  }
};
</script>

<style lang="css" scoped>
.foundation-modal-background,.modal-background{display:none;background-color:rgba(0,0,0,.5);position:fixed;top:0;left:0;width:100%;height:100%;z-index:11;}
.modal-background--secondary{background-color:rgba(0,0,0,.8)}
.page{position:relative;overflow-x:hidden;}
@media screen and (min-width:64em){.page{overflow:hidden}}
.page.minisite{background:#fff;min-height:100vh}
@keyframes forward{0%{stroke-dasharray:1 226.19467px;stroke-dashoffset:0}to{stroke-dasharray:226.19467px,226.19467px;stroke-dashoffset:0}}
@keyframes animate{
	0%{stroke-dasharray:1 226.19467px;stroke-dashoffset:0;animation-timing-function:cubic-bezier(.8,0,.9,1)}
	30%{stroke-dasharray:226.19467px,226.19467px;stroke-dashoffset:0;animation-timing-function:ease-out}
	65%{stroke-dasharray:1 226.19467px;stroke-dashoffset:-226.19467px;animation-timing-function:cubic-bezier(.8,0,.9,1)}
	to{stroke-dasharray:226.19467px,0;stroke-dashoffset:-226.19467px;animation-timing-function:cubic-bezier(.8,0,.9,1)}
}
@keyframes rotate-spinner{0%{transform:rotate(-200deg)}30%{transform:rotate(-90deg)}63%{transform:rotate(-60deg)}65%{transform:rotate(-200deg)}to{transform:rotate(-90deg)}}
@keyframes shift-top{0%{position:absolute;top:-100%;left:0}to{top:0}}
@keyframes shift-bottom{0%{position:absolute;top:0;left:0}to{top:100%}}
/* #1 */
@keyframes animate-arrow{0%{stroke-dasharray:1 226.19467px;stroke-dashoffset:0}to{stroke-dasharray:226.19467px,226.19467px;stroke-dashoffset:0}}
@keyframes rotate-forward{0%{transform:rotate(-200deg)}to{transform:rotate(-90deg)}}
.hidden{display:none}
html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}
article,aside,footer,header,nav,section{display:block}
h1{font-size:2em;margin:.67em 0}
figcaption,figure,main{display:block}
figure{margin:1em 40px}
hr{box-sizing:content-box;height:0;overflow:visible}
pre{font-family:monospace,monospace;font-size:1em}
a{background-color:transparent;-webkit-text-decoration-skip:objects}
a:active,a:hover{outline-width:0}
abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}
b,strong{font-weight:inherit;font-weight:bolder}
code,kbd,samp{font-family:monospace,monospace;font-size:1em}
dfn{font-style:italic}
mark{background-color:#ff0;color:#000}
sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}
sub{bottom:-.25em}
sup{top:-.5em}
audio,video{display:inline-block}
audio:not([controls]){display:none;height:0}
img{border-style:none}
svg:not(:root){overflow:hidden}
button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}
button,input{overflow:visible}
button,select{text-transform:none}
[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}
[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}
[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}
fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}
legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}
progress{display:inline-block;vertical-align:baseline}
textarea{overflow:auto}
[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}
[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}
[type=search]{-webkit-appearance:textfield;outline-offset:-2px}
[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}
::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}
details,menu{display:block}
summary{display:list-item}
canvas{display:inline-block}
[hidden],template{display:none}
blockquote,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,li,ol,p,pre,td,th,ul{margin:0;padding:0}
em,i{font-style:italic}
b,em,i,strong{line-height:inherit}
b,strong{font-weight:700}
small{font-size:80%;line-height:inherit}
address{font-style:normal}
dl,ol,ul{line-height:1.6;margin-bottom:1rem;list-style-position:outside}
li{font-size:inherit}
ul{list-style-type:none}
ol,ul{margin-left:0}
ol ol,ol ul,ul ol,ul ul{margin-left:0;margin-bottom:0}
p{font-size:inherit;line-height:1.6;margin-bottom:1rem;text-rendering:optimizeLegibility}
.heading-h1,.heading-h2,.heading-h3,.heading-h4,.heading-h5,.heading-h6,h1,h2,h3,h4,h5,h6{color:#000;margin-top:0;margin-bottom:.5rem}
.heading-h1,h1{font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;font-weight:400;font-style:normal;line-height:1.16}
.heading-h2,.heading-h4,.heading-h6,h2,h4,h6{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-weight:400;font-style:normal}
.heading-h3,h3{text-transform:uppercase;letter-spacing:.0625rem;display:block}
.heading-h3,.heading-h5,h3,h5{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-weight:400;font-style:normal;line-height:1.66}
.heading-h5,h5{letter-spacing:normal}
.heading-h2,h2{line-height:1.32}
.heading-h4,.heading-h6,h4,h6{line-height:1.5}
.heading-h1,.heading-h2,h1,h2{font-size:1.5625rem}
.heading-h3,h3{font-size:.75rem}
.heading-h4,h4{font-size:1rem}
.heading-h5,h5{font-size:.75rem}
.heading-h6,h6{font-size:.875rem}
@media screen and (min-width:48em){.heading-h1,h1{font-size:2.1875rem}.heading-h2,h2{font-size:1.5625rem}.heading-h3,h3{font-size:.75rem}.heading-h4,h4{font-size:1rem}.heading-h5,h5{font-size:.75rem}.heading-h6,h6{font-size:.875rem}}
@media screen and (min-width:64em){.heading-h1,h1{font-size:3.125rem}.heading-h2,h2{font-size:1.5625rem}.heading-h3,h3{font-size:.75rem}.heading-h4,h4{font-size:1rem}.heading-h5,h5{font-size:.75rem}.heading-h6,h6{font-size:.875rem}}
.link,a{color:#000;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.75rem;text-decoration:underline;line-height:inherit;cursor:pointer}
.link:focus,a:focus{text-decoration:none}
@media screen and (min-width:75em){.link:hover,a:hover{text-decoration:none}}
.link img,a img{border:0}
.link-with-arrow{position:relative;cursor:pointer}
.link-with-arrow:after{content:"";background:url(../../assets/imgs/icons/arrow-bigger.svg) no-repeat;width:.6875rem;height:.6875rem;position:absolute;bottom:.125rem;right:-1.25rem;transform:rotate(-90deg);transition:all .2s linear}
.link-with-arrow:hover{color:#c4926d}
.link-with-arrow:hover:after{background-image:url(../../assets/imgs/icons/arrow-bigger-hover.svg);right:-1.4375rem;transform:rotate(-90deg) scale(.9,1.4)}
html{font-size:100%;box-sizing:border-box}
@media screen and (min-width:64em){html{overflow-x:hidden}}
*,:after,:before{box-sizing:inherit}
body{padding:0;margin:0;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-weight:400;line-height:1.6;font-size:.8125rem;color:#575757;background:#fff;overflow-x:hidden;opacity:1;transition:opacity 1s;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}
body.fade-out{opacity:0;transition:none}
body:not(.popin-open):not(.no-scroll):not(.js-no-scroll){-webkit-overflow-scrolling:touch}
body.no-scroll-sticky{-webkit-overflow-scrolling:initial!important}
body.mouse-clicked a:focus,body.mouse-clicked a:focus-within,body.mouse-clicked area:focus,body.mouse-clicked area:focus-within,body.mouse-clicked button:focus,body.mouse-clicked button:focus-within,body.mouse-clicked div:focus,body.mouse-clicked div:focus-within,body.mouse-clicked iframe:focus,body.mouse-clicked iframe:focus-within,body.mouse-clicked input:focus,body.mouse-clicked input:focus-within,body.mouse-clicked select:focus,body.mouse-clicked select:focus-within,body.mouse-clicked textarea:focus,body.mouse-clicked textarea:focus-within{outline:none!important;outline-width:0!important;box-shadow:none!important;-moz-box-shadow:none!important;-webkit-box-shadow:none!important}
body.mouse-clicked a:after,body.mouse-clicked a:before,body.mouse-clicked area:after,body.mouse-clicked area:before,body.mouse-clicked button:after,body.mouse-clicked button:before,body.mouse-clicked div:after,body.mouse-clicked div:before,body.mouse-clicked iframe:after,body.mouse-clicked iframe:before,body.mouse-clicked input:after,body.mouse-clicked input:before,body.mouse-clicked select:after,body.mouse-clicked select:before,body.mouse-clicked textarea:after,body.mouse-clicked textarea:before{outline-color:transparent!important}
.text--bold{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
fieldset{border:0;padding:0;margin:0}
textarea{height:auto;min-height:50px}
select{width:100%;z-index:1!important}
button{-webkit-appearance:none;-moz-appearance:none;background:transparent;padding:0;border:0;border-radius:0;line-height:1}
input::-webkit-credentials-auto-fill-button{visibility:hidden;display:none;pointer-events:none;position:absolute;right:0}
form{position:relative}
.disabled{pointer-events:none}
img{-ms-interpolation-mode:bicubic;display:inline-block;vertical-align:middle}
img,object,video{max-width:100%;height:auto}
video::-webkit-media-controls-start-playback-button{display:none}
.lazyload{opacity:0}
.lazyloading{opacity:.25;transition:opacity .2s}
.lazyloaded{opacity:1;transition:opacity .2s}
.image--full-width{width:100%}
.image--fit{object-fit:cover;object-position:center;height:100%;width:100%}
@media (-ms-high-contrast:active),(-ms-high-contrast:none){.image--fit{position:absolute;width:100%;height:auto;top:0;left:50%;transform:translate(-50%)}}
.container,.container-fluid{margin-right:auto;margin-left:auto}
.container{width:100%;max-width:75rem}
.container-fluid{padding-right:2rem;padding-left:2rem}
.col.reverse{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}
.flex-column{flex-direction:column}
.col-xs,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-offset-0,.col-xs-offset-1,.col-xs-offset-2,.col-xs-offset-3,.col-xs-offset-4,.col-xs-offset-5,.col-xs-offset-6,.col-xs-offset-7,.col-xs-offset-8,.col-xs-offset-9,.col-xs-offset-10,.col-xs-offset-11,.col-xs-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
.col-xs{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
.col-xs-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
.col-xs-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
.col-xs-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
.col-xs-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
.col-xs-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
.col-xs-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
.col-xs-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
.col-xs-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
.col-xs-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
.col-xs-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
.col-xs-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
.col-xs-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
.col-xs-offset-0{margin-left:0}
.col-xs-offset-1{margin-left:8.33333333%}
.col-xs-offset-2{margin-left:16.66666667%}
.col-xs-offset-3{margin-left:25%}
.col-xs-offset-4{margin-left:33.33333333%}
.col-xs-offset-5{margin-left:41.66666667%}
.col-xs-offset-6{margin-left:50%}
.col-xs-offset-7{margin-left:58.33333333%}
.col-xs-offset-8{margin-left:66.66666667%}
.col-xs-offset-9{margin-left:75%}
.col-xs-offset-10{margin-left:83.33333333%}
.col-xs-offset-11{margin-left:91.66666667%}
.display-flex-xs{display:-webkit-box;display:-ms-flexbox;display:flex}
.ms-row.reversed{-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}
.ms-row,.ms-row.reversed{-webkit-box-orient:horizontal}
.ms-row{box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-.625rem;margin-left:-.625rem}
.flex-nowrap-md{flex-wrap:nowrap}
.flex-wrap{flex-wrap:wrap}
.ms-row--second{margin-left:-.5rem;margin-right:-.5rem}
.ms-row--second .col-xs,.ms-row--second .col-xs-1,.ms-row--second .col-xs-2,.ms-row--second .col-xs-3,.ms-row--second .col-xs-4,.ms-row--second .col-xs-5,.ms-row--second .col-xs-6,.ms-row--second .col-xs-7,.ms-row--second .col-xs-8,.ms-row--second .col-xs-9,.ms-row--second .col-xs-10,.ms-row--second .col-xs-11,.ms-row--second .col-xs-12,.ms-row--second .col-xs-offset-0,.ms-row--second .col-xs-offset-1,.ms-row--second .col-xs-offset-2,.ms-row--second .col-xs-offset-3,.ms-row--second .col-xs-offset-4,.ms-row--second .col-xs-offset-5,.ms-row--second .col-xs-offset-6,.ms-row--second .col-xs-offset-7,.ms-row--second .col-xs-offset-8,.ms-row--second .col-xs-offset-9,.ms-row--second .col-xs-offset-10,.ms-row--second .col-xs-offset-11,.ms-row--second .col-xs-offset-12{padding-right:.5rem;padding-left:.5rem}
.ms-row--third{margin-left:-.5rem;margin-right:-.5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third{margin-left:-.75rem;margin-right:-.75rem}}
.ms-row--third .col-xs,.ms-row--third .col-xs-1,.ms-row--third .col-xs-2,.ms-row--third .col-xs-3,.ms-row--third .col-xs-4,.ms-row--third .col-xs-5,.ms-row--third .col-xs-6,.ms-row--third .col-xs-7,.ms-row--third .col-xs-8,.ms-row--third .col-xs-9,.ms-row--third .col-xs-10,.ms-row--third .col-xs-11,.ms-row--third .col-xs-12,.ms-row--third .col-xs-offset-0,.ms-row--third .col-xs-offset-1,.ms-row--third .col-xs-offset-2,.ms-row--third .col-xs-offset-3,.ms-row--third .col-xs-offset-4,.ms-row--third .col-xs-offset-5,.ms-row--third .col-xs-offset-6,.ms-row--third .col-xs-offset-7,.ms-row--third .col-xs-offset-8,.ms-row--third .col-xs-offset-9,.ms-row--third .col-xs-offset-10,.ms-row--third .col-xs-offset-11,.ms-row--third .col-xs-offset-12{padding-right:.5rem;padding-left:.5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs,.ms-row--third .col-xs-1,.ms-row--third .col-xs-2,.ms-row--third .col-xs-3,.ms-row--third .col-xs-4,.ms-row--third .col-xs-5,.ms-row--third .col-xs-6,.ms-row--third .col-xs-7,.ms-row--third .col-xs-8,.ms-row--third .col-xs-9,.ms-row--third .col-xs-10,.ms-row--third .col-xs-11,.ms-row--third .col-xs-12,.ms-row--third .col-xs-offset-0,.ms-row--third .col-xs-offset-1,.ms-row--third .col-xs-offset-2,.ms-row--third .col-xs-offset-3,.ms-row--third .col-xs-offset-4,.ms-row--third .col-xs-offset-5,.ms-row--third .col-xs-offset-6,.ms-row--third .col-xs-offset-7,.ms-row--third .col-xs-offset-8,.ms-row--third .col-xs-offset-9,.ms-row--third .col-xs-offset-10,.ms-row--third .col-xs-offset-11,.ms-row--third .col-xs-offset-12{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-padding-sm--left{padding-left:calc(8.33333% - .75rem)}.ms-row--third .col-padding-sm--right{padding-right:calc(8.33333% - .75rem)}}
.ms-row--third .col-padding-xs{padding:0 calc(8.33333% - .5rem)}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-padding-xs{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-padding-xs{padding-right:.5rem;padding-left:.5rem}}
.ms-row--third .col-xs--expanded-right{padding:0 calc(8.33333% - .5rem) 0 .5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs--expanded-right{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-xs--expanded-right{padding-right:.5rem;padding-left:.5rem}}
.ms-row--third .col-xs--expanded-left{padding:0 .5rem 0 calc(8.33333% - .5rem)}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs--expanded-left{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-xs--expanded-left{padding-right:.5rem;padding-left:.5rem}}
.ms-row.collapsed{margin-left:0;margin-right:0}
.ms-row.collapsed .col-xs,.ms-row.collapsed .col-xs-1,.ms-row.collapsed .col-xs-2,.ms-row.collapsed .col-xs-3,.ms-row.collapsed .col-xs-4,.ms-row.collapsed .col-xs-5,.ms-row.collapsed .col-xs-6,.ms-row.collapsed .col-xs-7,.ms-row.collapsed .col-xs-8,.ms-row.collapsed .col-xs-9,.ms-row.collapsed .col-xs-10,.ms-row.collapsed .col-xs-11,.ms-row.collapsed .col-xs-12,.ms-row.collapsed .col-xs-offset-0,.ms-row.collapsed .col-xs-offset-1,.ms-row.collapsed .col-xs-offset-2,.ms-row.collapsed .col-xs-offset-3,.ms-row.collapsed .col-xs-offset-4,.ms-row.collapsed .col-xs-offset-5,.ms-row.collapsed .col-xs-offset-6,.ms-row.collapsed .col-xs-offset-7,.ms-row.collapsed .col-xs-offset-8,.ms-row.collapsed .col-xs-offset-9,.ms-row.collapsed .col-xs-offset-10,.ms-row.collapsed .col-xs-offset-11,.ms-row.collapsed .col-xs-offset-12{padding-right:0;padding-left:0}
.ms-row.expanded{margin-right:-.625rem;margin-left:-.625rem}
.flex-fill{flex-grow:1}
.start-xs{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
.center-xs{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
.end-xs{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
.top-xs{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
.middle-xs{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
.bottom-xs{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
.self-bottom-xs{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
.around-xs{-ms-flex-pack:distribute;justify-content:space-around}
.between-xs{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
.first-xs{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
.last-xs{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
@media screen and (min-width:48em){
	.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-offset-0,.col-sm-offset-1,.col-sm-offset-2,.col-sm-offset-3,.col-sm-offset-4,.col-sm-offset-5,.col-sm-offset-6,.col-sm-offset-7,.col-sm-offset-8,.col-sm-offset-9,.col-sm-offset-10,.col-sm-offset-11,.col-sm-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
	.col-sm{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
	.col-sm-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
	.col-sm-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
	.col-sm-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
	.col-sm-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
	.col-sm-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
	.col-sm-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
	.col-sm-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
	.col-sm-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
	.col-sm-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
	.col-sm-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
	.col-sm-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
	.col-sm-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
	.col-sm-offset-0{margin-left:0}
	.col-sm-offset-1{margin-left:8.33333333%}
	.col-sm-offset-2{margin-left:16.66666667%}
	.col-sm-offset-3{margin-left:25%}
	.col-sm-offset-4{margin-left:33.33333333%}
	.col-sm-offset-5{margin-left:41.66666667%}
	.col-sm-offset-6{margin-left:50%}
	.col-sm-offset-7{margin-left:58.33333333%}
	.col-sm-offset-8{margin-left:66.66666667%}
	.col-sm-offset-9{margin-left:75%}
	.col-sm-offset-10{margin-left:83.33333333%}
	.col-sm-offset-11{margin-left:91.66666667%}
	.display-flex-sm{display:-webkit-box;display:-ms-flexbox;display:flex}
	.start-sm{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
	.center-sm{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
	.end-sm{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
	.top-sm{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
	.middle-sm{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
	.bottom-sm{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
	.self-bottom-sm{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
	.around-sm{-ms-flex-pack:distribute;justify-content:space-around}
	.between-sm{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
	.first-sm{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
	.last-sm{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
@media screen and (min-width:64em){
	.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-offset-0,.col-md-offset-1,.col-md-offset-2,.col-md-offset-3,.col-md-offset-4,.col-md-offset-5,.col-md-offset-6,.col-md-offset-7,.col-md-offset-8,.col-md-offset-9,.col-md-offset-10,.col-md-offset-11,.col-md-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
	.col-md{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
	.col-md-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
	.col-md-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
	.col-md-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
	.col-md-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
	.col-md-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
	.col-md-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
	.col-md-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
	.col-md-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
	.col-md-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
	.col-md-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
	.col-md-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
	.col-md-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
	.col-md-offset-0{margin-left:0}
	.col-md-offset-1{margin-left:8.33333333%}
	.col-md-offset-2{margin-left:16.66666667%}
	.col-md-offset-3{margin-left:25%}
	.col-md-offset-4{margin-left:33.33333333%}
	.col-md-offset-5{margin-left:41.66666667%}
	.col-md-offset-6{margin-left:50%}
	.col-md-offset-7{margin-left:58.33333333%}
	.col-md-offset-8{margin-left:66.66666667%}
	.col-md-offset-9{margin-left:75%}
	.col-md-offset-10{margin-left:83.33333333%}
	.col-md-offset-11{margin-left:91.66666667%}
	.display-flex-md{display:-webkit-box;display:-ms-flexbox;display:flex}
	.start-md{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
	.center-md{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
	.end-md{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
	.top-md{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
	.middle-md{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
	.bottom-md{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
	.self-bottom-md{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
	.around-md{-ms-flex-pack:distribute;justify-content:space-around}
	.between-md{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
	.first-md{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
	.last-md{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
@media screen and (min-width:75em){
	.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-offset-0,.col-lg-offset-1,.col-lg-offset-2,.col-lg-offset-3,.col-lg-offset-4,.col-lg-offset-5,.col-lg-offset-6,.col-lg-offset-7,.col-lg-offset-8,.col-lg-offset-9,.col-lg-offset-10,.col-lg-offset-11,.col-lg-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
	.col-lg{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
	.col-lg-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
	.col-lg-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
	.col-lg-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
	.col-lg-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
	.col-lg-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
	.col-lg-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
	.col-lg-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
	.col-lg-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
	.col-lg-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
	.col-lg-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
	.col-lg-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
	.col-lg-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
	.col-lg-offset-0{margin-left:0}
	.col-lg-offset-1{margin-left:8.33333333%}
	.col-lg-offset-2{margin-left:16.66666667%}
	.col-lg-offset-3{margin-left:25%}
	.col-lg-offset-4{margin-left:33.33333333%}
	.col-lg-offset-5{margin-left:41.66666667%}
	.col-lg-offset-6{margin-left:50%}
	.col-lg-offset-7{margin-left:58.33333333%}
	.col-lg-offset-8{margin-left:66.66666667%}
	.col-lg-offset-9{margin-left:75%}
	.col-lg-offset-10{margin-left:83.33333333%}
	.col-lg-offset-11{margin-left:91.66666667%}
	.display-flex-lg{display:-webkit-box;display:-ms-flexbox;display:flex}
	.start-lg{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
	.center-lg{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
	.end-lg{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
	.top-lg{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
	.middle-lg{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
	.bottom-lg{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
	.self-bottom-lg{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
	.around-lg{-ms-flex-pack:distribute;justify-content:space-around}
	.between-lg{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
	.first-lg{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
	.last-lg{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
.hide{display:none!important}
.show{display:block!important}
@media screen and (max-width:47.9375em){.hide-for-xs-only{display:none!important}}
@media screen and (max-width:63.9375em){.show-for-md{display:none!important}}
.clearfix:after,.clearfix:before{content:" ";display:table}
.clearfix:after{clear:both}
.text--no-transform{text-transform:none}
.text--white{color:#fff}
.text--black{color:#000}
.text--right{text-align:right}
.layout{max-width:75rem;margin:0 auto;position:relative}
.layout--large{max-width:103.75rem}
.layout--full-width{width:100%;max-width:100%}
.c-button{display:inline-block;vertical-align:middle;padding:.8125rem 1.875rem;-webkit-appearance:none;border-radius:1.375rem;transition:background-color .25s ease-out,color .25s ease-out;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.625rem;line-height:1;letter-spacing:.0625rem;text-align:center;cursor:pointer;text-decoration:none;text-transform:uppercase;background:transparent;border:.0625rem solid #cacaca;color:#000}
@media screen and (min-width:48em){.c-button{font-size:.75rem;padding:.9375rem 1.875rem}}
.c-button .c-button:focus,.c-button:hover{text-decoration:none;background-color:transparent;border-color:#cacaca;color:#000;outline:none}
.c-button[disabled]:not(.c-button--inactive){opacity:.65;cursor:not-allowed}
.c-button--secondary{display:inline-block;vertical-align:middle;padding:.8125rem 1.875rem;-webkit-appearance:none;border-radius:1.375rem;transition:background-color .25s ease-out,color .25s ease-out;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.625rem;line-height:1;letter-spacing:.0625rem;text-align:center;cursor:pointer;text-decoration:none;text-transform:uppercase;background:transparent;border:.0625rem solid #cacaca;color:#000}
@media screen and (min-width:48em){.c-button--secondary{font-size:.75rem;padding:.9375rem 1.875rem}}
.c-button--secondary .c-button--secondary:focus,.c-button--secondary:hover{text-decoration:none;background-color:#000;border-color:#cacaca;color:#fff;outline:none}
.c-button--secondary-reversed-hover{background-color:transparent;border-color:#fff;color:#fff}
.c-button--secondary-reversed-hover:hover{background-color:#fff;border-color:#fff;color:#000}
.c-button--secondary-reversed-hover:focus{color:#000}
.c-button--rounded{border-radius:50%;padding:0;width:2.375rem;height:2.375rem;position:relative;background:transparent;border-color:#cacaca;color:#000}
.c-button--rounded .c-button--rounded:focus,.c-button--rounded:hover{text-decoration:none;background-color:transparent;border-color:#cacaca;color:#000;outline:none}
.c-button--rounded .svg-inline,.c-button--rounded img{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:block}
.c-button--close .cross-inverted{visibility:hidden;width:.75rem;height:.75rem}
.c-button--close:hover{background:#000;border-color:#cacaca;color:#000}
.c-button--close:hover .c-button--close:hover:focus,.c-button--close:hover:hover{text-decoration:none;background-color:#000;border-color:#000;color:#000;outline:none}
.c-button--close:hover .cross{visibility:hidden}
.c-button--close:hover .cross-inverted{visibility:visible;transform:translate(-50%,-50%) rotate(180deg);transition:all .2s linear}
.c-button--close:hover .cross-inverted polygon{fill:#fff}
/* #2 */
@keyframes colorTop{0%{border-left-color:#000}25%{border-top-color:#000}50%{border-right-color:#000}}
.c-newsletter-subscribe__input{margin:.875rem 0 0}
@media screen and (min-width:48em){.c-newsletter-subscribe__input{margin:0}}
.c-newsletter-subscribe__form .c-newsletter-subscribe__input{padding-bottom:0}
@media screen and (min-width:48em){.c-newsletter-subscribe__form .c-newsletter-subscribe__input{padding-bottom:1.25rem}}
@media screen and (min-width:48em){.c-newsletter-subscribe__form-container{margin-top:1.25rem}}
.c-newsletter-subscribe__text{padding:0 1.0625rem}
.c-newsletter-subscribe__message{margin:0 auto}
.c-newsletter-subscribe__message-wrapper{display:flex;align-items:center;justify-content:center}
.c-newsletter-subscribe__message-text{margin-left:.625rem;color:#fff}
.c-newsletter-subscribe .c-input{width:100%}
@media screen and (min-width:48em){.c-newsletter-subscribe .c-input{width:18rem}}
.c-input{height:2.8125rem;border-radius:1.40625rem;font-size:.8125rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;padding:.875rem 1.25rem .8125rem;background:#fff;border:.0625rem solid #cacaca;color:#cacaca;color:#575757}
.c-input.is-invalid{border-color:#c53131}
.c-input--no-border{border:none}
.form-group{padding-bottom:1.5625rem;position:relative}
input::-ms-clear,input::-ms-reveal{display:none}
.c-container{padding:0 1rem}
@media screen and (min-width:48em){.c-container{padding:0 10.75rem}}
@media screen and (min-width:64em){.c-container{padding:0 3.875rem}}
@media screen and (min-width:75em){.c-container{padding:0}}
.c-container--minisite{padding:0 3.0625rem}
@media screen and (min-width:48em){.c-container--minisite{padding:0 3.875rem}}
@media screen and (min-width:64em){.c-container--minisite{padding:0}}
@media screen and (max-width:47.9375em){.c-container--padding-xs{padding:0 .9375rem}}
.sr-only{border:0!important;clip:rect(1px,1px,1px,1px)!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:1px!important;white-space:nowrap!important}
.animated--secondary{-webkit-animation-duration:.6s;animation-duration:.6s;-webkit-animation-fill-mode:both;animation-fill-mode:both;animation-timing-function:cubic-bezier(.77,0,.175,1)}
.fadeOut{animation-duration:.4s;-webkit-animation-fill-mode:both;animation-fill-mode:both;animation-name:fadeOut}
@media screen and (min-width:64em){.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}
.fadeIn{opacity:0}
.fadeIn.go{-webkit-animation-name:fadeIn;animation-name:fadeIn}
.fadeInDownShort{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}
.fadeInDownShort.go{-webkit-animation-name:fadeInDownShort;animation-name:fadeInDownShort}
}
@keyframes fadeIn{0%{opacity:0}to{opacity:1;display:block}}
@-webkit-keyframes fadeInDownShort{0%{opacity:0;-webkit-transform:translateY(-20px)}to{opacity:1;-webkit-transform:translateY(0)}}
@keyframes fadeInDownShort{0%{opacity:0;transform:translateY(-20px)}to{opacity:1;transform:translateY(0)}}
@keyframes fadeOut{0%{opacity:1}to{opacity:0}}
.c-minisite-banner{position:relative}
.c-minisite-banner__background{height:40.8125rem;overflow:hidden}
@media screen and (min-width:48em){.c-minisite-banner__background{height:64.25rem}}
@media screen and (min-width:64em){.c-minisite-banner__background{height:69.9375rem}}
.c-minisite-banner__picture{display:flex;height:100%}
.c-minisite-banner__content{width:100%;position:absolute;bottom:22%}
.c-minisite-title{font-size:1.5625rem;font-family:PlayfairDisplay-Italic,arial,sans-serif;line-height:2.0625rem}
@media screen and (min-width:48em){.c-minisite-title{font-size:2.5rem;line-height:3.8rem}}
@media screen and (min-width:64em){.c-minisite-title{font-size:2.5rem}}
.c-minisite-title .text--italic{font-family:PlayfairDisplay-Italic,arial,sans-serif;font-size:inherit;line-height:inherit}
.c-minisite-title--secondary{font-size:3.125rem;font-family:PlayfairDisplay-Bold,arial,sans-serif;line-height:1;margin-bottom:2.5rem}
@media screen and (min-width:48em){.c-minisite-title--secondary{font-size:3.75rem;margin-bottom:3.3125rem}}
@media screen and (min-width:64em){.c-minisite-title--secondary{margin-bottom:3.125rem}}
.c-minisite-title--highlight{background-color:#000;color:#fff;padding:.1rem 0;margin-left:.4375rem;-webkit-box-shadow:.4375rem 0 0 #000,-.4375rem 0 0 #000;-ms-box-shadow:.4375rem 0 0 #000,-.4375rem 0 0 #000;-o-box-shadow:.4375rem 0 0 #000,-.4375rem 0 0 #000;box-shadow:.4375rem 0 0 #000,-.4375rem 0 0 #000;-webkit-box-decoration-break:clone;-ms-box-decoration-break:clone;-o-box-decoration-break:clone;box-decoration-break:clone}
@media screen and (min-width:48em){.c-minisite-title--highlight{font-size:3.75rem;line-height:1.16;padding:0}}
.c-minisite-text--bold{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
.c-minisite-content{padding:8.8125rem 0 9.375rem}
@media screen and (min-width:48em){.c-minisite-content{padding:6.875rem 0 6.25rem}}
@media screen and (min-width:64em){.c-minisite-content{padding:11.875rem 0 6.8125rem}}
.c-minisite-content--bottom{padding-top:0}
.c-minisite-content--pre-carousel{padding-bottom:9.375rem}
.c-minisite-content--carousel{display:flex;flex-direction:column}
.c-minisite-content--light{background:#fff;color:#000}
.m-foundation{margin-top:0}
/* @media screen and (min-width:64em){.m-foundation{margin-top:-11.75rem}} */
.m-foundation .text--no-padding{padding:0}
.m-foundation .c-minisite-content{padding:4.625rem 0 8.75rem}
@media screen and (min-width:64em){.m-foundation .c-minisite-content{padding:5.3125rem 0 19.375rem}}
.m-foundation .c-minisite-content__small{padding:0}
.m-foundation .c-minisite-carousel__text-secondary{font-size:1rem;line-height:1.5rem}
.m-foundation .m-minisite__description{margin-bottom:0}
@media screen and (min-width:64em){.m-foundation .m-minisite__description{margin-left:0}}
.m-foundation .c-minisite-banner .c-minisite-title--highlight{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:1.5625rem;line-height:2.5625rem}
@media screen and (min-width:48em){.m-foundation .c-minisite-banner .c-minisite-title--highlight{font-size:2.5rem;line-height:3.5625rem}}
.m-foundation .c-minisite-banner .c-minisite-banner__content .c-container{padding:0 1rem}
@media screen and (min-width:48em){.m-foundation .c-minisite-banner .c-minisite-banner__content .c-container{padding:0 3.9375rem}}
.m-foundation .c-minisite-title--secondary{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.5rem;line-height:2.4rem}
@media screen and (min-width:48em){.m-foundation .c-minisite-title--secondary{font-size:3.125rem}}
@media screen and (min-width:64em){.m-foundation .c-minisite-title--secondary{line-height:3rem}}
.m-foundation .c-minisite-title--secondary span{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.5rem;line-height:2.4rem}
@media screen and (min-width:48em){.m-foundation .c-minisite-title--secondary span{font-size:3.125rem}}
@media screen and (min-width:64em){.m-foundation .c-minisite-title--secondary span{margin-left:0;line-height:3rem}}
.c-minisite-content--carousel{margin-bottom:0}
@media screen and (max-width:47.9375em){.c-minisite-content--carousel{padding:0}}
@media screen and (min-width:48em){.c-minisite-content--carousel{margin-bottom:0;padding:0}}
@media screen and (min-width:64em){.c-minisite-content--carousel{margin-bottom:9.75rem}}
/* #3 */
.m-foundation-section .c-carousel .c-carousel__pagination{padding-top:1.875rem}
.m-foundation-section .c-carousel__slider-info{margin-left:-2.3125rem}
/* #4 */
.c-minisite-content--pre-carousel{padding-bottom:6.25rem}
@media screen and (min-width:48em){.c-minisite-content--pre-carousel{padding-bottom:18.75rem}}
.m-fondation-content__carousel-text-primary{font-size:2.5rem;line-height:1.2}
@media screen and (min-width:48em){.m-fondation-content__carousel-text-primary{font-size:3.125rem;line-height:1.16}}
.m-fondation-content__carousel-text-primary--bold{font-family:PlayfairDisplay-Bold,arial,sans-serif}
.m-fondation-content__carousel-text-primary--regular{font-family:PlayfairDisplay-Regular,arial,sans-serif}
.m-fondation-content__carousel-text-primary--italic{font-family:PlayfairDisplay-Italic,arial,sans-serif}
.m-foundation-content__text-block--third{padding-top:3.75rem}
@media screen and (min-width:48em){.m-foundation-content__text-block--third{padding-top:11.25rem;margin:0}}
@media screen and (min-width:75em){.m-foundation-content__text-block--third{padding-top:7.5rem}}
@media screen and (max-width:47.9375em){.m-fondation-content__box-primary-wrapper{height:8.125rem;text-align:center}}
.m-foundation-content__text-block--right,.m-foundation-content__text-block--third{align-self:center;font-size:1.5625rem;line-height:1.8125rem;font-family:PlayfairDisplay-Italic,arial,sans-serif;display:flex;margin-left:auto;margin-right:auto;justify-content:center}
@media screen and (min-width:48em){.m-foundation-content__text-block--right,.m-foundation-content__text-block--third{font-size:1.4375rem;line-height:1.4;order:2}}
@media screen and (min-width:75em){.m-foundation-content__text-block--right,.m-foundation-content__text-block--third{order:0;display:flex;justify-content:center;margin:0;line-height:1.875rem}
.m-foundation-content__text-block--right .m-quote__author,.m-foundation-content__text-block--third .m-quote__author{font-size:.8125rem}}
.m-foundation-content__text-block--right .m-quote__author,.m-foundation-content__text-block--third .m-quote__author{font-size:.8125rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;margin-top:1.875rem;padding-left:0;line-height:1.3125rem}
@media screen and (min-width:48em){.m-foundation-content__text-block--right .m-quote__author,.m-foundation-content__text-block--third .m-quote__author{margin-top:1.875rem}}
@media screen and (min-width:75em){.m-foundation-content__text-block--right .m-quote__author,.m-foundation-content__text-block--third .m-quote__author{margin-top:1.5625rem}}
.m-foundation-content__text-block--right .m-quote__sign,.m-foundation-content__text-block--third .m-quote__sign{width:1rem}
@media screen and (min-width:48em){.m-foundation-content__text-block--right .m-quote__sign,.m-foundation-content__text-block--third .m-quote__sign{width:1.5625rem}}
.m-foundation-content__text-block--right .m-quote__sign-img,.m-foundation-content__text-block--third .m-quote__sign-img{width:100%}
.m-foundation-content__text-block--right .m-quote__sign--first,.m-foundation-content__text-block--third .m-quote__sign--first{margin-top:-1.75rem;margin-right:1rem;margin-left:-2rem}
@media screen and (min-width:48em){.m-foundation-content__text-block--right .m-quote__sign--first,.m-foundation-content__text-block--third .m-quote__sign--first{margin-top:-.75rem;margin-left:-2.5rem}
}@media screen and (min-width:75em){.m-foundation-content__text-block--right .m-quote__sign--first,.m-foundation-content__text-block--third .m-quote__sign--first{margin-right:1.375rem;margin-left:-3rem}}
.m-foundation-content__text-block--right .m-quote__sign--last,.m-foundation-content__text-block--third .m-quote__sign--last{margin-bottom:3.125rem;margin-left:1rem;margin-right:-2rem;display:flex;align-items:flex-end}
@media screen and (min-width:48em){.m-foundation-content__text-block--right .m-quote__sign--last,.m-foundation-content__text-block--third .m-quote__sign--last{margin-right:-2.5rem;margin-bottom:3.5625rem}}
@media screen and (min-width:75em){.m-foundation-content__text-block--right .m-quote__sign--last,.m-foundation-content__text-block--third .m-quote__sign--last{margin-right:0;margin-left:-1.625rem}}
.m-foundation-content__text-block--right .m-quote__sign--start,.m-foundation-content__text-block--third .m-quote__sign--start{margin-top:-1.875rem;margin-right:1rem;margin-left:-2rem}
@media screen and (min-width:48em){.m-foundation-content__text-block--right .m-quote__sign--start,.m-foundation-content__text-block--third .m-quote__sign--start{margin-top:-.75rem;margin-left:-2.5rem}}
.m-foundation-content__text-block--right .m-quote__sign--final,.m-foundation-content__text-block--third .m-quote__sign--final{margin-bottom:4.0625rem;margin-left:1rem;margin-right:-2rem;display:flex;align-items:flex-end}
@media screen and (min-width:48em){.m-foundation-content__text-block--right .m-quote__sign--final,.m-foundation-content__text-block--third .m-quote__sign--final{margin-right:0;margin-left:-1.4375rem;margin-bottom:3.75rem}}
.m-foundation-content__text-block--right .m-quote__wrapper,.m-foundation-content__text-block--third .m-quote__wrapper{width:100%}
@media screen and (max-width:47.9375em){.m-foundation-content__text-block--right .m-quote__wrapper,.m-foundation-content__text-block--third .m-quote__wrapper{max-width:16.25rem}}
.m-foundation-content__container-primary .m-foundation-content__text-block--right{padding-top:5.1875rem;margin:0 0 3.625rem}
@media screen and (min-width:48em){.m-foundation-content__container-primary .m-foundation-content__text-block--right{padding-top:3.625rem;margin:0 8% 57px}}
@media screen and (min-width:75em){.m-foundation-content__container-primary .m-foundation-content__text-block--right{padding-top:0;margin-top:-7.5rem}}
@media screen and (min-width:48em) and (max-width:63.9375em){.m-foundation-content .c-container--minisite{padding:0 3.9375rem}}
@media screen and (min-width:64em) and (max-width:74.9375em){.m-foundation-content .c-container--minisite{padding:0 3.875rem}}
@media screen and (min-width:48em) and (max-width:63.9375em){.m-foundation-content .c-container--minisite__carousel{padding-bottom:9.375rem}}
.m-foundation-content .c-container--minisite .c-minisite-title--secondary{margin-bottom:1.5625rem}
@media screen and (min-width:48em){.m-foundation-content .c-container--minisite .c-minisite-title--secondary{margin-bottom:2.6875rem}}
@media screen and (min-width:64em){.m-foundation-content .c-container--minisite .c-minisite-title--secondary{margin-bottom:2.1875rem}}
.m-foundation-content__image-wrapper.c-minisite-content{padding-top:3rem}
@media screen and (min-width:48em){.m-foundation-content__image-wrapper.c-minisite-content{padding:5.9375rem 0 0}}
@media screen and (min-width:64em){.m-foundation-content__image-wrapper.c-minisite-content{padding-top:10.3125rem}}
.m-foundation-content .m-foundation-content__description-primary{font-size:1rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;line-height:1.5;margin-top:.9375rem}
.m-foundation-content .m-foundation-content__description-primary:last-child{margin-bottom:0}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__description-primary:last-child{margin-bottom:0;margin-top:.3125rem}}
@media screen and (min-width:64em){.m-foundation-content .m-foundation-content__description-primary:last-child{margin-bottom:0}}
.m-foundation-content .m-foundation-content__description-secondary{font-size:1.5625rem;font-family:PlayfairDisplay-Bold,arial,sans-serif;margin-top:4.6875rem;margin-bottom:0}
.m-foundation-content .m-foundation-content__image--secondary{margin:2.5rem 0 0;max-width:16.3125rem}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__image--secondary{max-width:19.75rem;margin:-15.625rem 0 0}}
@media screen and (min-width:75em){.m-foundation-content .m-foundation-content__image--secondary{max-width:24.3125rem;margin:10.75rem 0 0}}
.m-foundation-content .m-foundation-content__image--third{margin-top:3.125rem;max-width:14.3125rem}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__image--third{max-width:23.25rem;margin-left:0}}
@media screen and (min-width:64em){.m-foundation-content .m-foundation-content__image--third{margin-left:10.9375rem}}
@media screen and (min-width:75em){.m-foundation-content .m-foundation-content__image--third{max-width:24.3125rem;margin:-11.25rem 0 0}}
.m-foundation-content .m-foundation-content__image--fifth{max-width:14.3125rem}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__image--fifth{max-width:19.8125rem;margin-left:5.625rem}}
@media screen and (min-width:64em){.m-foundation-content .m-foundation-content__image--fifth{margin-left:13.75rem}}
@media screen and (min-width:75em){.m-foundation-content .m-foundation-content__image--fifth{max-width:24.3125rem;margin-left:0}}
.m-foundation-content .m-foundation-content__text-block{font-size:1.25rem;font-family:PlayfairDisplay-Regular,arial,sans-serif}
.m-foundation-content .m-foundation-content__image-container .m-foundation-content__image--fourth{max-width:17.3125rem}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__image-container .m-foundation-content__image--fourth{max-width:26.3125rem}}
@media screen and (min-width:75em){.m-foundation-content .m-foundation-content__image-container .m-foundation-content__image--fourth{max-width:37rem}}
.m-foundation-content .m-foundation-content__arch-container{padding-top:2.1875rem}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__arch-container{padding-top:3.4375rem}}
.m-foundation-content .m-foundation-content__arch-text--primary{margin-bottom:0;font-size:1rem;width:100%;background:#fff;margin-top:-1.5625rem;position:relative}
.m-foundation-content .m-foundation-content__arch-text--secondary{font-family:PlayfairDisplay-Bold,arial,sans-serif;line-height:3rem;font-size:3.125rem}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__arch-text--secondary{line-height:4.625rem;font-size:3.75rem}}
@media screen and (min-width:64em){.m-foundation-content .m-foundation-content__arch-text--secondary{line-height:4.25rem}}
.m-foundation-content .m-foundation-content__arch--text--third{margin-top:.9375rem;font-size:1rem;line-height:1.5rem}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__arch--text--third{margin-top:.3125rem}}
@media screen and (min-width:64em){.m-foundation-content .m-foundation-content__arch--text--third{margin-top:1.5625rem}}
.m-foundation-content .m-foundation-content__actions-container{padding-top:0}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__actions-container{padding-top:9.375rem}}
.m-foundation-content .m-foundation-content__project-container{padding-top:4.6875rem;display:flex;justify-content:space-between}
.m-foundation-content .m-foundation-content__projects-container{padding:3.8125rem 0 0}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__projects-container{margin-top:1.3125rem}}
@media screen and (min-width:64em){.m-foundation-content .m-foundation-content__projects-container{margin-top:6.6875rem}}
@media screen and (min-width:75em){.m-foundation-content .m-foundation-content__projects-container{padding:.125rem 0 .1875rem}}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__projects-container:first-child{margin-top:6.8125rem}}
@media screen and (min-width:64em){.m-foundation-content .m-foundation-content__projects-container:first-child{margin-top:9.375rem}}
.m-foundation-content .m-foundation-content__projects-container:last-child{margin-bottom:5.125rem;padding-bottom:0}
@media screen and (min-width:64em){.m-foundation-content .m-foundation-content__projects-container:last-child{margin-bottom:9.8125rem}}
.m-foundation-content .m-foundation-content__projects-title--primary{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.1875rem;font-style:normal;font-stretch:normal;line-height:1.27;letter-spacing:normal}
@media screen and (min-width:48em){.m-foundation-content .m-foundation-content__projects-title--primary{font-size:2.3125rem}}
.m-foundation-content .m-foundation-content__projects-title--secondary{font-family:300;font-size:1rem;font-style:normal;font-stretch:normal;line-height:1.5rem;letter-spacing:normal}
.m-foundation-content .m-foundation-content__projects-title--third{z-index:2;font-weight:700;font-size:.75rem;text-decoration:underline;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;top:.625rem}
.js-project-modal-wrapper .m-foundation-content .c-container--minisite .c-minisite-title--secondary{line-height:1.75rem;margin-bottom:2.3125rem}
@media screen and (min-width:48em){.js-project-modal-wrapper .m-foundation-content .c-container--minisite .c-minisite-title--secondary{margin-bottom:3.5625rem}}
@media screen and (min-width:64em){.js-project-modal-wrapper .m-foundation-content .c-container--minisite .c-minisite-title--secondary{margin-bottom:5.375rem}}
.js-project-modal-wrapper .c-button--close{right:-1.5625rem}
@media screen and (max-width:47.9375em){.js-project-modal-wrapper .c-button--close{top:-2.5rem}}
@media screen and (min-width:48em){.js-project-modal-wrapper .c-button--close{right:0}}
.js-project-modal-wrapper .c-minisite-content{padding:3.5rem 0 9.375rem}
@media screen and (min-width:64em){.js-project-modal-wrapper .c-minisite-content{padding:12.25rem 0 9.375rem}}
.c-foundation-newsletter{padding:5.3125rem 0 0}
@media screen and (min-width:48em){.c-foundation-newsletter{padding:5rem 0 0}}
@media screen and (min-width:75em){.c-foundation-newsletter{padding:.3125rem 0 6.5625rem}}
/* 隐藏注册表单的处理#Begin */
/*\
 .c-foundation-newsletter .c-foundation-newsletter__text{min-height:17.875rem}
@media screen and (min-width:48em){.c-foundation-newsletter .c-foundation-newsletter__text{min-height:19rem}}
@media screen and (min-width:64em){.c-foundation-newsletter .c-foundation-newsletter__text{min-height:20.6875rem}} 
\*/
@media screen and (min-width:64em){.c-foundation-newsletter .c-foundation-newsletter__text{min-height:10.6875rem}}
@media screen and (min-width:75em){.c-foundation-newsletter .c-foundation-newsletter__text{min-height:5.6875rem}}
/* 隐藏注册表单的处理#End */
.c-foundation-newsletter .m-foundation-newsletter__title{text-align:center;font-family:PlayfairDisplay-Bold,arial,sans-serif;font-size:2.1875rem;line-height:1;font-style:normal}
@media screen and (min-width:48em){.c-foundation-newsletter .m-foundation-newsletter__title{font-size:2.3125rem;padding:0 7.5rem}}
@media screen and (min-width:75em){.c-foundation-newsletter .m-foundation-newsletter__title{max-width:26.25rem;padding:0;margin:0 auto}}
.c-foundation-newsletter .m-foundation-newsletter__description{text-align:center;font-family:PlayfairDisplay-Italic,arial,sans-serif;font-size:2.1875rem;line-height:1.27;font-style:normal;margin-bottom:.1875rem}
@media screen and (min-width:48em){.c-foundation-newsletter .m-foundation-newsletter__description{font-size:2.3125rem;padding:0 1.875rem;margin-bottom:1.125rem}}
@media screen and (min-width:48em){.c-foundation-newsletter .c-foundation-newsletter__fields{display:flex;justify-content:center}}
.c-foundation-newsletter .c-newsletter-subscribe__form-container{margin-top:0}
@media screen and (min-width:48em){.c-foundation-newsletter.c-newsletter-subscribe .c-input{margin-right:1rem}}
.c-foundation-newsletter .c-newsletter-subscribe__message{margin-top:1.25rem}
@media screen and (min-width:48em){.c-foundation-newsletter .c-newsletter-subscribe__message{margin-top:0}}
.c-foundation-newsletter__btn{font-size:.75rem}
@media screen and (max-width:47.9375em){.c-foundation-newsletter__btn{width:100%}}
.c-foundation-wrapper{padding:3.75rem 0 0}
@media screen and (min-width:48em){.c-foundation-wrapper{padding:6.25rem 0 1.25rem}}
@media screen and (min-width:75em){.c-foundation-wrapper{padding:8.75rem 0 5.9375rem}}
.m-foundation__address{line-height:1.62;margin-top:1rem}
.c-solidarity{position:fixed;z-index:999;top:0;left:-100%;width:100%;height:100vh;overflow:scroll;}
.c-solidarity.opened{left:0;overflow: hidden;}
@media screen and (min-width:64em){.c-solidarity{width:74%}}
.c-solidarity .m-foundation-content{height: 100%;overflow-y: auto;overflow-x: hidden;min-height: 100%;}
.c-solidarity .m-foundation-content__projects{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.75rem;line-height:1.67}
.c-solidarity-content{padding-bottom:4.8125rem}
@media screen and (min-width:48em){.c-solidarity-content{padding-bottom:6.0625rem}}
@media screen and (min-width:64em){.c-solidarity-content{padding-bottom:8rem}}
.c-solidarity-content .c-solidarity-content__title-primary{font-size:.75rem;line-height:1.67;color:#000;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;padding-top:2.1875rem}
@media screen and (min-width:64em){.c-solidarity-content .c-solidarity-content__title-primary{padding-top:0}}
.c-solidarity-content .c-solidarity-content__title-primary p{margin-bottom:.3125rem}
.c-solidarity-content .c-solidarity-content__title-secondary{font-size:1.25rem;color:#000;font-family:PlayfairDisplay-Italic,arial,sans-serif}
.c-solidarity-content .c-solidarity-content__description{font-size:.8125rem;line-height:1.62;color:#000;font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif}
.c-minisite-carousel__container{height:auto;position:relative;top:-9.375rem;left:0;margin-bottom:-9.375rem}
@media screen and (min-width:48em){.c-minisite-carousel__container{height:auto;position:relative;top:-18.75rem;left:0;margin-bottom:-18.75rem}}
.c-minisite-carousel__arrows-container{height:100%;display:flex;flex-direction:column}
.c-minisite-carousel__arrows{height:100%;flex-direction:row;justify-content:flex-end;align-items:flex-end;padding-bottom:1rem;display:none}
@media screen and (min-width:48em){.c-minisite-carousel__arrows{display:flex}}
.c-minisite-carousel__btn{position:relative;width:3.125rem;height:3.125rem;background-color:transparent;}
.c-minisite-carousel__btn:before{display:none}
.c-minisite-carousel__btn.slick-arrow:after{background:url(../../assets/imgs/icons/arrow-big-white.svg) no-repeat 50%;position:absolute;top:50%;left:50%}
@media screen and (min-width:64em){.c-minisite-carousel__btn.slick-arrow:hover{background-color:#fff}.c-minisite-carousel__btn.slick-arrow:hover:after{background:url(../../assets/imgs/icons/arrow-big.svg) no-repeat 50%}}
.c-minisite-carousel__btn--next{margin-left:1.25rem}
.c-minisite-carousel__btn--next:after{transform:translate(-50%,-50%) rotate(-90deg)}
.c-minisite-carousel__btn--prev:after{transform:translate(-50%,-50%) rotate(90deg)}
.c-minisite-carousel__img{max-height:11.5625rem;max-width:17.3125rem;margin-bottom:1.25rem}
@media screen and (min-width:48em){.c-minisite-carousel__img{max-height:24.5625rem;max-width:36.8125rem;margin-bottom:1.875rem}}
@media screen and (min-width:64em){.c-minisite-carousel__img{max-height:39.75rem;max-width:49.625rem}}
.c-minisite-carousel__slide-inner{height:auto;max-width:17.3125rem;padding:.3125rem 0}
@media screen and (min-width:48em){.c-minisite-carousel__slide-inner{height:auto;max-width:36.8125rem;padding:.625rem 0}}
@media screen and (min-width:64em){.c-minisite-carousel__slide-inner{height:auto;max-width:49.625rem;padding:1.5625rem 0 2.5rem}}
/* #5 */
.c-minisite-tile__title{font-family:PlayfairDisplay-Bold,arial,sans-serif;font-size:1.5625rem;line-height:1.375rem;margin-bottom:1.25rem}
.c-minisite-tile__title .text--italic{font-family:PlayfairDisplay-Italic,arial,sans-serif;font-size:1.5625rem}
@media screen and (min-width:48em){.c-minisite-tile__title .text--italic{font-size:1.4375rem}}
/* #6 */
.c-carousel .c-carousel__pagination{width:auto;font-size:.8125rem;margin:0 auto;position:relative;align-items:center;z-index:1;}
.c-carousel .c-carousel__slider-info{display:flex;color:#000;line-height:1.5625rem}
/* #7 */
.c-carousel .c-carousel__slide-num{position:relative;margin-right:.25rem;overflow:hidden;width:1.125rem;height:1.5625rem;text-align:right;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:.8125rem}
.c-carousel .c-carousel__slide-num .shift-top{animation:shift-top 1s linear}
.c-carousel .c-carousel__slide-num .shift-bottom{animation:shift-bottom 1s linear}
.c-carousel .c-carousel__next-slide{width:100%;position:absolute;top:-100%;right:0}
.c-carousel .c-carousel__current-slide{width:100%;position:absolute;top:0;right:0}
.c-carousel .c-carousel__total-slides-num{margin-left:.25rem;width:1.125rem;text-align:left;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
/* #8 */
</style>

<!-- 因需精确还原, 无奈使用基于jQuery的轮播组件Slick, 导致Vue组件生成的scope样式带属性选择器需要拆分 -->
<style>
/* #1 */
.c-minisite-slider__spinner{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);display:flex;font-size:0}
.c-minisite-slider__spinner svg{flex:1}
.c-minisite-slider__spinner circle{fill:none;stroke:#fff;stroke-linecap:square}
.c-minisite-slider__spinner--black circle{stroke:#000}
.c-minisite-slider__spinner.forward circle{animation:forward 2s cubic-bezier(.8,0,.9,1)}
.c-minisite-slider__spinner.forward svg{animation:rotate-forward 2s ease-out}
.c-minisite-slider__spinner.animate svg{animation:rotate-spinner 3.5s}
.c-minisite-slider__spinner.animate circle{animation:animate 3.5s}
/* #2 */
.slick-slider{box-sizing:border-box;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:pan-y;touch-action:pan-y}
.slick-list,.slick-slider{position:relative;display:block}
.slick-list{overflow:hidden;margin:0}
.slick-list:focus{outline:none}
.slick-list.dragging{cursor:pointer}
.slick-track{position:relative;left:0;top:0;display:block;margin-left:auto;margin-right:auto}
.slick-track:after,.slick-track:before{content:"";display:table}
.slick-track:after{clear:both}
.slick-slide{float:left;max-height:100%;min-height:1px;outline:none;position:relative}
.slick-slider:not(.slick-initialized) .slick-slide{display:none}
.slick-initialized .slick-slide.slick-active .lazyload,.slick-initialized .slick-slide.slick-current .lazyload{display:block}
.slick-arrow{position:relative;border-radius:50%;border:.0625rem solid #dfdfdf;padding:1.3125rem;cursor:pointer;transition:background-color .2s linear}
@media screen and (min-width:64em){
	.slick-arrow:before{content:"";position:absolute;left:0;top:0;width:100%;height:100%;border-radius:100%;border:1px solid transparent;transition:border-top-color .15s linear,border-left-color .15s linear .3s,border-bottom-color .15s linear,border-right-color .15s linear .1s,transform .4s linear 0s}
	.slick-arrow:hover{background-color:#000;border-color:#fff}
	.slick-arrow:hover:after{background:url(../../assets/imgs/icons/arrow-big-white.svg) no-repeat 50%}
}
.slick-arrow:after{content:"";background:url(../../assets/imgs/icons/arrow-big.svg) no-repeat 50%;display:block;width:.875rem;height:.875rem}
.slick-next:after{transform:rotate(270deg);-webkit-transform:rotate(270deg)}
.slick-prev:after{transform:rotate(90deg);-webkit-transform:rotate(90deg)}
.slick-disabled{visibility:hidden}
.slick-active button{color:#fff;border-bottom:.125rem solid #fff;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.75rem;margin:0 .5rem}
.slick-active button:before{content:none}
.slick-active:first-of-type button{margin-left:0}
@media screen and (min-width:64em){.slick-arrow--animated:before{transform:rotate(225deg);animation:colorTop 1s}}
/* #3 */
@media screen and (min-width:64em){
	.m-foundation-section .c-minisite-content--carousel .slick-arrow:hover{background-color:#000}
	.m-foundation-section .c-minisite-content--carousel .slick-arrow:hover:after{background:url(../../assets/imgs/icons/arrow-bigger-white.svg) no-repeat 50%}
	.m-foundation-section .c-minisite-content--carousel .slick-arrow:hover.slick-arrow--animated{background-color:#fff;border-color:#dfdfdf}
	.m-foundation-section .c-minisite-content--carousel .slick-arrow:hover.slick-arrow--animated:after{background:url(../../assets/imgs/icons/arrow-big.svg) no-repeat 50%}
}
/* #4 */
.m-foundation-section .c-carousel .slick-arrow{bottom:-3.75rem;top:unset}
.m-foundation-section .c-carousel .c-carousel__btn{top:auto;bottom:-3.75rem}
.m-foundation-section .c-carousel .c-carousel__btn--next{margin-left:2.0625rem}
.m-foundation-section .c-carousel .c-carousel__btn--prev{margin-left:-4.4375rem}
@media screen and (max-width:47.9375em){.m-foundation-section .c-minisite-carousel__container{top:-6rem;margin-bottom:-4.125rem}}
@media screen and (min-width:48em) and (max-width:63.9375em){.m-foundation-section .c-minisite-carousel__container{top:-14rem;margin-bottom:-10.3125rem}}
/* #5 */
.c-minisite-carousel .slick-list{margin:0 auto;overflow:visible;padding:0 2.5rem}
@media screen and (min-width:48em){.c-minisite-carousel .slick-list{padding:0 3.125rem}}
@media screen and (min-width:64em){.c-minisite-carousel .slick-list{max-width:69.75rem;padding:0}}
.c-minisite-carousel .slick-slide{padding:0 .5625rem}
.c-minisite-carousel .slick-slide.slick-cloned{display:none}
@media screen and (min-width:48em){.c-minisite-carousel .slick-slide{padding:0 .75rem}}
@media screen and (min-width:64em){.c-minisite-carousel .slick-slide{transition:opacity 1s;padding:0 3.6875rem}}
/* #6 */
.c-carousel .slick-arrow{position:absolute;bottom:-1.875rem;top:auto;left:50%;transform:translateX(-50%);z-index:2;width:2.375rem;height:2.375rem;padding:0;border:.0625rem solid #dfdfdf;border-radius:50%;transition:none}
.c-carousel .slick-arrow:before{display:none}
.c-carousel .slick-arrow:after{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:url(../../assets/imgs/icons/arrow-bigger.svg) no-repeat 50%}
@media screen and (min-width:64em){.c-carousel .slick-arrow:hover{background-color:#000;border-color:#000}.c-carousel .slick-arrow:hover:after{background:url(../../assets/imgs/icons/arrow-bigger-white.svg) no-repeat 50%}}
/* #7 */
.c-carousel .c-carousel__btn--next{margin-left:3.75rem}
.c-carousel .c-carousel__btn--next:after{transform:translate(-50%,-50%) rotate(-90deg)}
.c-carousel .c-carousel__btn--prev{margin-left:-3.75rem}
.c-carousel .c-carousel__btn--prev:after{transform:translate(-50%,-50%) rotate(90deg)}
/* #8 */
.c-carousel .c-minisite-slider__spinner{overflow:hidden}
.c-carousel .c-minisite-slider__spinner svg{transform:rotate(-90deg)}
.c-carousel .c-minisite-slider__spinner circle{stroke-dasharray:1 226.19467px;stroke-dashoffset:-226.19467px}
.c-carousel .c-minisite-slider__spinner.animate-arrow svg{animation:rotate-forward 1s ease-out}
.c-carousel .c-minisite-slider__spinner.animate-arrow circle{animation:animate-arrow 1s cubic-bezier(.8,0,.9,1)}
</style>